import { useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";

import CopyLinkIcon from "assets/icons/member-get-member/copy-link-icon.svg";
import ShareIcon from "assets/icons/member-get-member/share-icon.svg";
import LinearEditSvg from "assets/icons/linear-edit.svg";

import { ClientArea } from "components/ClientArea";
import { ArrowButton } from "components/ArrowButton";
import { Button } from "components/Button";
import { FormItem } from "components/FormItem";
import { Input } from "components/Input";

import { CardResponsible } from "./CardResponsible";
import { UnityArea } from "./UnityArea";
import { AttachmentArea } from "./AttachmentArea";

import { useClient } from "hooks/budget/client";
import { useToast } from "hooks/toast";
import { usePmoc } from "hooks/usePmoc";
import { useHistory } from "react-router";

import { api } from "services/api";

import { hasLettersAndNumbers } from "utils/verifyHasLettersAndNumbers";
import { hasLowercaseLetters } from "utils/hasLowercaseLetters";

import * as S from "./styles";

import { LoadingProfiz } from "components/LoadingProfiz";
import { ModalRight } from "components/ModalRight";
import { ShareOnSocialMediaModal } from "components/ShareOnSocialMediaModal";

import { ScheduledComponent } from "./ScheduledComponent";
import { format } from "date-fns";

type RouteParams = {
  id: string;
};

type ARTFileProps = {
  url: string;
};

type DictOption = {
  [key: string]: { status: string };
};

type DictMonthOption = {
  [key: string]: number;
};

type RouteState = {
  selectedYearPMOC?: number;
};

function StatePmoc(statusPmoc: string) {
  const status: DictOption = {
    Pendente: {
      status: "pending",
    },
    execução: {
      status: "execution",
    },
    Concluída: {
      status: "concluded",
    },
  };
  let value = Object.keys(status).find((key) => {
    const sts = status[key];
    return sts.status === statusPmoc;
  });

  return (
    <S.WapperPmocStatus>
      <div className="element-ball" />
      <p className="text-status">
        {statusPmoc === "execution" && "Em "}
        {value}
      </p>
    </S.WapperPmocStatus>
  );
}

type EnvironmentProps = {
  environmentId: number | string;
  environmentName: string;
  equipments: [
    {
      equipmentId: number | string;
      equipmentTag: string;
    }
  ];
};

type ServiceOrderHistoryProps = {
  year: number;
  months: OSProps[];
};

type OSProps = {
  month: string;
  percentageComplete: string;
};

export function PmocConcludedRegisterForm() {
  const { id } = useParams<RouteParams>();
  const location = useLocation<RouteState>();
  const history = useHistory();
  const { addToast } = useToast();
  const {
    initialPmocProps,
    periodProps,
    handleSetUnity,
    handleSetPeriodProps,
    handleSetPmocArtFile,
    handleSetInitialPmocProps,
    handleSetStartDate,
    clearPmocData,
  } = usePmoc();

  const { clearClientData, handleSetClient } = useClient();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [shareModalIsVisible, setShareModalIsVisible] = useState(false);
  const [sharedLink, setSharedLink] = useState("");

  const [hasErrorOnHash, setHasErrorOnHash] = useState<string[]>([]);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [visibleButtonSaveHash, setVisibleButtonSaveHash] = useState(false);
  const [randomHash, setRandomHash] = useState("");

  const inputRef = useRef<HTMLInputElement>(null);

  const [isNotCloseModalEnvironment, setIsNotClosedModalEnvironment] =
    useState(true);

  const [environmentsList, setEnvironmentsList] = useState<EnvironmentProps[]>(
    [] as EnvironmentProps[]
  );

  const [serviceOrderHistory, setServiceOrderHistory] = useState<
    ServiceOrderHistoryProps[]
  >([] as ServiceOrderHistoryProps[]);
  const [stepPage, setStepPage] = useState(0);
  const [stepModal, setStepModal] = useState(false);

  const [orderServiceList, setOrderServiceList] = useState<OSProps[]>(
    [] as OSProps[]
  );

  const [selectedYear, setSelectedYear] = useState(0);

  const [scheduledModal, setScheduledModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);

  const [statusPmoc, setStatusPmoc] = useState("concluded");

  const clearInfos = async () => {
    clearClientData();
    clearPmocData();
  };

  const setData = async () => {
    try {
      setIsLoadingModal(true);
      const response = await api.get(`/pmoc/${id}`);

      response.data &&
        response.data.id &&
        response.data.name &&
        handleSetInitialPmocProps({
          id: response.data.id,
          name: response.data.name,
        });

      response.data &&
        response.data.status &&
        setStatusPmoc(response.data.status);

      response.data &&
        response.data.status &&
        setStatusPmoc(response.data.status);

      response.data &&
        response.data.client &&
        handleSetClient(response.data.client);
      response.data &&
        response.data.unity &&
        handleSetUnity(response.data.unity);

      response.data &&
        response.data.contractPeriod &&
        response.data.contractPeriod.period &&
        response.data.contractPeriod.type &&
        handleSetPeriodProps({
          period: response.data.contractPeriod.period,
          frequency: response.data.contractPeriod.type,
        });

      response.data && response.data.art
        ? handleSetPmocArtFile({
            url: response.data.art,
          })
        : handleSetPmocArtFile({} as ARTFileProps);

      response.data &&
        response.data.environments &&
        setEnvironmentsList(response.data.environments);

      response.data &&
        response.data.years &&
        setServiceOrderHistory(response.data.years);

      response.data &&
        response.data.startDate &&
        handleSetStartDate(response.data.startDate);

      setSharedLink(
        `${window.location.origin}/public/pmoc/view/client/${response.data?.hashClientView}`
      );

      response.data &&
        response.data.passClientView &&
        setRandomHash(response.data.passClientView);

      if (
        response.data &&
        response.data.years &&
        response.data.years.length === 1
      ) {
        filterOSPercentage(response.data.years[0].year, response.data.years);
        setStepPage(1);

        if (location?.state?.selectedYearPMOC) {
          setStepModal(true);
        }
      }

      if (
        location?.state?.selectedYearPMOC &&
        response?.data?.years.length > 1
      ) {
        filterOSPercentage(
          location?.state?.selectedYearPMOC,
          response.data.years
        );
        setStepPage(1);
        setStepModal(true);
      }
    } catch (error) {
      addToast({
        title: "Erro",
        description:
          axios.isAxiosError(error) && error.response?.data.error
            ? error.response?.data.error
            : "Não foi possível carregar as informações do PMOC",
        type: "error",
      });
    } finally {
      setIsLoadingModal(false);
    }
  };

  useEffect(() => {
    setData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isNotCloseModalEnvironment) {
      setData();
      setIsNotClosedModalEnvironment(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNotCloseModalEnvironment]);

  function filterOSPercentage(
    year: number,
    osList: ServiceOrderHistoryProps[]
  ) {
    try {
      setIsLoadingModal(true);

      setSelectedYear(year);
      let osFilter = osList.find((os) => {
        return Number(os.year) === Number(year);
      });
      osFilter && setOrderServiceList(osFilter.months);
    } catch (error) {
      addToast({
        title: "Erro",
        description:
          "Não foi possível obter a listagem de ordens de serviço pelo ano escolhido",
        type: "error",
      });
    } finally {
      setIsLoadingModal(false);
    }
  }

  function handleChangeInput(text: string) {
    setRandomHash(text.trim().toUpperCase());

    if (inputRef.current?.value.trim()) setVisibleButtonSaveHash(true);
    else setVisibleButtonSaveHash(false);
  }

  function handleToggleEnableInput() {
    setIsInputDisabled(false);
    inputRef.current?.focus();
  }

  async function handleSaveRandomHash() {
    try {
      setIsLoading(true);
      let hashErrors: string[] = [];
      if (!randomHash) {
        hashErrors = [...hashErrors, "Campo obrigatório"];
      }

      if (randomHash.length !== 6) {
        hashErrors = [...hashErrors, "O campo deve conter 6 caracteres."];
      }

      if (!hasLettersAndNumbers(randomHash)) {
        hashErrors = [...hashErrors, "O campo deve conter letras e números."];
      }

      if (hasLowercaseLetters(randomHash)) {
        hashErrors = [...hashErrors, "Todas as letras tem que ser maiúsculas."];
      }

      if (hashErrors.length > 0) {
        setHasErrorOnHash(hashErrors);
        return;
      }

      await api.put(`/pmoc/${initialPmocProps.id}/view/client/password`, {
        pmocUserClientPass: randomHash,
      });

      setHasErrorOnHash([]);
      setIsInputDisabled(true);
      setVisibleButtonSaveHash(false);

      addToast({
        type: "success",
        title: "Código de acesso atualizado com sucesso",
      });
    } catch (error) {
      addToast({
        title: "Erro",
        description:
          axios.isAxiosError(error) && error.response?.data.error
            ? error.response?.data.error
            : "Não foi possível atualizar o código de acesso.",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  }

  const truncateStr = (str: string, size: number) => {
    var shortText = str;
    if (str.length >= size + 3) {
      shortText = str.substring(0, size).concat("...");
    }
    return shortText;
  };

  const handleCopyIndicationURL = () => {
    navigator.clipboard.writeText(sharedLink);
    setIsCopied(true);
  };

  function monthToNumber(month: string) {
    const dictMonth: DictMonthOption = {
      janeiro: 1,
      fevereiro: 2,
      março: 3,
      abril: 4,
      maio: 5,
      junho: 6,
      julho: 7,
      agosto: 8,
      setembro: 9,
      outubro: 10,
      novembro: 11,
      dezembro: 12,
    };
    return dictMonth[month.toLowerCase()];
  }

  function handleChangeDate(day: Date) {
    setSelectedDate(day);
  }

  async function handleUpdatePmoc() {
    try {
      if (!selectedDate) return;
      setIsLoading(true);

      await api.put(`/pmoc/${initialPmocProps.id}`, {
        startDate: format(selectedDate, "yyyy-MM-dd"),
      });

      addToast({
        type: "success",
        title: "PMOC atualizado com sucesso.",
      });

      setScheduledModal(false);

      await setData();
    } catch (error) {
      addToast({
        title: "Erro",
        description:
          axios.isAxiosError(error) && error.response?.data.error
            ? error.response?.data.error
            : "Não foi possível atualizar o PMOC",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      {isLoadingModal ? (
        <LoadingProfiz isVisible={isLoadingModal} />
      ) : (
        <S.Container>
          <ShareOnSocialMediaModal
            isVisible={shareModalIsVisible}
            onCloseModal={() => {
              setShareModalIsVisible(false);
            }}
            sharedLink={sharedLink}
          ></ShareOnSocialMediaModal>

          <ModalRight
            isOpen={scheduledModal}
            handleToggleOpen={() => setScheduledModal(false)}
          >
            <ScheduledComponent
              closeModal={() => {
                setScheduledModal(false);
              }}
              loading={isLoading}
              selectedDate={selectedDate}
              handleChangeDate={handleChangeDate}
              handleUpdatePmoc={handleUpdatePmoc}
            />
          </ModalRight>

          <ModalRight
            isOpen={stepModal}
            handleToggleOpen={() => {
              setStepModal(false);
            }}
          >
            {stepPage < 1 ? (
              <>
                <S.Container>
                  <ArrowButton
                    handleFunction={() => {
                      setStepModal(false);
                    }}
                  />
                  <S.ModalHeader>
                    <p className="title">Histórico de ordens de serviço</p>
                    <p className="subtitle">
                      Acompanhe o histórico das ordens de serviço deste PMOC.
                    </p>
                  </S.ModalHeader>
                  <div>
                    {serviceOrderHistory.map((os, index) => {
                      return (
                        <S.OSCard
                          key={index}
                          typeCursor="pointer"
                          onClick={() => {
                            filterOSPercentage(os.year, serviceOrderHistory);
                            setStepPage(1);
                          }}
                        >
                          <p className="text">{os.year}</p>
                        </S.OSCard>
                      );
                    })}
                  </div>
                </S.Container>
              </>
            ) : (
              <>
                <S.Container>
                  <ArrowButton
                    handleFunction={() => {
                      if (serviceOrderHistory.length === 1)
                        return setStepModal(false);
                      setStepPage(0);
                    }}
                  />

                  <S.ModalHeader>
                    <p className="title">Histórico de ordens de serviço</p>
                    <p className="subtitle">
                      Acompanhe o histórico das ordens de serviço deste PMOC.
                    </p>
                  </S.ModalHeader>

                  <div>
                    {orderServiceList.map((os, index) => {
                      return (
                        <S.OSCard
                          key={index}
                          typeCursor="pointer"
                          onClick={() => {
                            let monthNumber = monthToNumber(
                              os.month.toLocaleLowerCase()
                            );
                            history.push(
                              `/pmoc/execution/order-services-list/${initialPmocProps.id}/${selectedYear}/${monthNumber}?statusList=0`
                            );
                          }}
                        >
                          <p className="text">{os.month}</p>
                          <p className="text">
                            {os.percentageComplete}% concluído
                          </p>
                        </S.OSCard>
                      );
                    })}
                  </div>
                </S.Container>
              </>
            )}
          </ModalRight>

          <div style={{ marginTop: 20 }}>
            <ArrowButton
              handleFunction={() => {
                history.push("/pmoc?statusList=2");
                clearInfos();
              }}
            />
          </div>
          <header>
            <S.Title>{initialPmocProps.name} </S.Title>
            {StatePmoc(statusPmoc)}
          </header>

          <div className="content">
            <S.Wrapper>
              <ClientArea disableDeleteButton disableEditButton />
            </S.Wrapper>

            <S.Wrapper>
              <UnityArea disableDeleteButton disableEditButton />
            </S.Wrapper>

            <S.Wrapper>
              <CardResponsible />
            </S.Wrapper>

            <S.Wrapper>
              {periodProps && periodProps.period ? (
                <FormItem
                  name="Período do contrato*"
                  placeholder={periodProps.period + " " + periodProps.frequency}
                  disabled
                />
              ) : (
                <FormItem
                  name="Período do contrato*"
                  placeholder={`Sem período cadastrado`}
                  disabled
                />
              )}
            </S.Wrapper>

            <S.WrapperInput>
              <div>
                <Input
                  name="Código de acesso da PMOC*"
                  placeholder="Ex: A1B2C3"
                  value={randomHash}
                  onChange={(e) => handleChangeInput(e.target.value)}
                  customRef={inputRef}
                  readOnly={isInputDisabled}
                  labelIcon="Ativar campo de código"
                  icon={visibleButtonSaveHash ? "" : LinearEditSvg}
                  onClickIcon={handleToggleEnableInput}
                  hasError={hasErrorOnHash[0]}
                  maxLength={6}
                />
              </div>

              {visibleButtonSaveHash && (
                <S.ButtonSaveHash onClick={handleSaveRandomHash}>
                  Salvar
                </S.ButtonSaveHash>
              )}
            </S.WrapperInput>

            {hasErrorOnHash.length > 0 &&
              hasErrorOnHash.map((error) => (
                <S.WrapperHashError>
                  <span>*{error}</span>
                </S.WrapperHashError>
              ))}

            <S.WrapperInfo>
              <span>
                O código de acessso serve para liberar os dados da PMOC no
                painel do cliente.
              </span>
            </S.WrapperInfo>

            <S.Wrapper>
              <AttachmentArea disable={true} />
            </S.Wrapper>

            {environmentsList && environmentsList.length > 0 && (
              <S.Wrapper>
                <S.TitleExecutionButton>
                  Ambientes e equipamentos
                </S.TitleExecutionButton>
                {environmentsList.map((element) => {
                  return (
                    <S.EnvironmentList key={element.environmentId}>
                      <p className="card-title"> {element.environmentName} </p>
                      <p className="card-text">
                        {" "}
                        |{" "}
                        {element.equipments.length > 1
                          ? `${element.equipments.length} equipamentos`
                          : `${element.equipments.length} equipamento`}{" "}
                      </p>
                    </S.EnvironmentList>
                  );
                })}
              </S.Wrapper>
            )}

            <S.Wrapper>
              <Button
                onClick={() => {
                  if (serviceOrderHistory.length === 1) {
                    setStepPage(1);
                  } else {
                    setStepPage(0);
                  }
                  setStepModal(true);
                }}
                typeButton="outlineDisable"
              >
                Histórico de ordens de serviço
              </Button>
            </S.Wrapper>

            <S.ShareArea>
              <S.IndicationLink>{truncateStr(sharedLink, 50)}</S.IndicationLink>
              <S.CopyButton onClick={handleCopyIndicationURL}>
                <img src={CopyLinkIcon} alt="copiar link de indicação" />
                <S.CopyText>{isCopied ? "Copiado" : "Copiar"}</S.CopyText>
              </S.CopyButton>
              <S.ShareButton onClick={() => setShareModalIsVisible(true)}>
                <img src={ShareIcon} alt="compartilhar" />
                <p>Compartilhar</p>
              </S.ShareButton>
            </S.ShareArea>
          </div>
        </S.Container>
      )}
    </>
  );
}
